import React from 'react'
import { TableRowField } from '../../../../components'
import moment from 'moment';

export function employeeDetailXS() {
    return ([
        {
            dataField: 'xs',
            text: 'Venta',
            formatter: (cell, row) => {
                let details = []
                for (const service of row.Services) {
                    details.push(service.name + ": S/." + service.price)
                }
                for (const product of row.Products) {
                    details.push(product.name + ": S/." + product.price)
                }
                const detailsNames = details.join(", ")

                return (
                    <div>
                        <TableRowField label='Fecha de atención:' value={moment(row.created_at).format('DD-MM-YYYY HH:mm')} />
                        <TableRowField label='Código:' value={row.receipt_id} />
                        <TableRowField label='Cliente:' value={row.Customer.name + " " + row.Customer.lastname} />
                        <TableRowField label='Detalle:' value={detailsNames} />
                        <TableRowField label='Total' value={row.TotalServiceProduct} />
                    </div>
                )
            }
        }
    ])
}

export function employeeDetail() {
    return ([
        {
            dataField: 'created_at',
            text: 'Fecha de atención',
            formatter: (cell, row) => {
                return (
                    <span>{moment(row.created_at).format('DD-MM-YYYY HH:mm')}</span>
                )
            }
        },
        {
            dataField: 'receipt_id',
            text: 'Código',
        },
        {
            dataField: 'Customer',
            text: 'Cliente',
            formatter: (cell, row) => {
                return (
                    <span>{row.Customer.name + " " + row.Customer.lastname}</span>
                )
            }
        },
        {
            dataField: 'Services',
            text: 'Detalle',
            formatter: (cell, row) => {
                if (row.Services.length == 0 && row.Products.length == 0) return (<span>{"Sin Detalles"}</span>)
                let index = 0
                for (const service of row.Services) {
                    service.id = index
                    index++
                }
                return (
                    <div>
                        {row.Services.map(service => <div key={`S${service.id}${service.price}`}> {service.name + ": S/." + service.price} </div>)}
                        {row.Products.map(product => <div key={`P${product.id}${product.price}`}> {product.name + ": S/." + product.price} </div>)}
                    </div>
                )
            }
        },
        {
            dataField: 'Total',
            text: 'Total',
            formatter: (cell, row) => {
                return (
                    <span>{'S/. ' + row.TotalServiceProduct.toFixed(2)}</span>
                )
            }
        },
    ])
}

export function employeeItemsDetailXS() {
    return ([
        {
            dataField: 'xs',
            text: 'Items',
            formatter: (cell, row) => {
                return (
                    <div>
                        <TableRowField label='Nombre:' value={row.item} />
                        <TableRowField label='Tipo:' value={row.type} />
                        <TableRowField label='Cantidad:' value={row.quantity} />
                        <TableRowField label='Total:' value={row.total} />
                    </div>
                )
            }
        }
    ])
}

export function employeeItemsDetail() {
    return ([
        {
            dataField: 'item',
            text: 'Nombre',
        },
        {
            dataField: 'type',
            text: 'Tipo',
        },
        {
            dataField: 'quantity',
            text: 'Cantidad',
        },
        {
            dataField: 'total',
            text: 'Total',
            formatter: (cell, row) => {
                return (
                    <span>{'S/. ' + row.total.toFixed(2)}</span>
                )
            }
        },
    ])
}


// WEBPACK FOOTER //
// ./src/scenes/Administration/Employee/EmployeeDetail/_columns.js